import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Form, Input, Button, Row, Col, Steps } from 'antd';
import get from 'lodash/get';

import htmlToDraft from 'html-to-draftjs';
import draftToMarkdown from 'draftjs-to-markdown';
import { EditorState, convertToRaw, ContentState } from 'draft-js';

import { withRouter } from 'react-router';

import WysiwygEditor from 'components/WysiwygEditor';
import TncPreviewModal from '../TncPreviewModal/TncPreviewModal.component';

import text from '../../containers/TncCreate/TncCreate.page.translation';

import './TncForm.style.less';

const { Step } = Steps;

class TncForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      tncContent: {
        en: props.currentValue.content.en,
        id: props.currentValue.content.id,
      },
      errorText: '',
      pristine: true,
      tncModalVisible: false,
    };
  }

  _updateState = value => {
    this.setState(value);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentValue !== this.props.currentValue) {
      this._updateState({
        tncContent: {
          en: this.props.currentValue.content.en,
          id: this.props.currentValue.content.id,
        },
      });
    }
  }

  checkEmpty = html => {
    if (editorState === '') {
      return true;
    }

    const contentBlock = htmlToDraft(html || '');
    let editorState;
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      editorState = EditorState.createWithContent(contentState);
    }

    const content = draftToMarkdown(
      convertToRaw(editorState.getCurrentContent()),
    ).trim();
    const separateContent = content.split(';">');
    let isEmpty = false;

    if (
      (separateContent.length === 1 && separateContent[0].length === 0) ||
      (separateContent.length > 1 && separateContent[1].length === 7)
    ) {
      isEmpty = true;
    }

    return isEmpty;
  };

  onValidate = lang => (err, formValues) => {
    const { tncContent } = this.state;
    const {
      onSubmit,
      currentValue,
      intl: { formatMessage },
    } = this.props;

    const isEmpty = this.checkEmpty(unescape(tncContent[lang]));

    if (!err && !isEmpty) {
      if (lang === 'en') {
        this.setState({ step: 1 }, () => {
          this.setState({ step: 2, pristine: true });
        });
      } else {
        const valueParams = {
          name: formValues.name,
          version_name: get(currentValue, 'fileVersion'),
          content: tncContent,
        };
        onSubmit(valueParams);
      }
    }

    this.setState({
      pristine: false,
      errorText: isEmpty ? formatMessage(text.form.empty) : '',
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;
    const lang = this.state.step === 0 ? 'en' : 'id';

    validateFields(['name'], this.onValidate(lang));
  };

  handleCancel = () => {
    if (this.state.step === 0) {
      this.props.history.goBack();
    } else {
      this.setState({ step: 1 }, () => {
        this.setState({
          step: 0,
          errorText: '',
        });
      });
    }
  };

  handlePreview = () => {
    this.setState({ tncModalVisible: true });
  };

  onChangeTnC = lang => (isEmpty, html, editorState) => {
    this.setState(prevState => {
      let errorText = prevState.pristine
        ? ''
        : this.props.intl.formatMessage(text.form.empty);

      if (!isEmpty) {
        errorText = '';
      }

      return {
        tncContent: {
          ...prevState.tncContent,
          [lang]: html,
        },
        errorText,
        editorState: {
          ...prevState.editorState,
          [lang]: editorState,
        },
      };
    });
  };

  renderTnCEditor = lang => {
    if (this.state.step === 1) {
      return null;
    }

    return (
      <WysiwygEditor
        errorText={this.state.errorText}
        initialValue={unescape(this.state.tncContent[lang])}
        onChange={this.onChangeTnC(lang)}
      />
    );
  };

  renderFormTab = (lang, visible) => {
    const {
      form: { getFieldDecorator, getFieldValue },
      intl: { formatMessage },
      isEdit,
      currentValue,
    } = this.props;

    return (
      <div style={{ display: visible ? 'block' : 'none' }}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              required
              colon={false}
              label={formatMessage(text.form.name)}
              extra={formatMessage(text.form.nameExtra)}
            >
              {getFieldDecorator(`name`, {
                initialValue:
                  lang === 'en'
                    ? get(currentValue, `name`)
                    : getFieldValue('name'),
                rules: [
                  {
                    required: true,
                    message: 'File Name is Required',
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  disabled={isEdit || lang === 'id'}
                  placeholder="Ex. TNC_AllBiller_General_InternetCableTV"
                />,
              )}
            </Form.Item>
          </Col>

          <Col span={isEdit ? 6 : 12}>
            <Form.Item
              colon={false}
              label={formatMessage(text.form.version)}
              extra={formatMessage(text.form.versionExtra)}
            >
              {getFieldDecorator(`fileVersion`, {
                initialValue: get(currentValue, `fileVersion`),
              })(<Input type="text" size="large" disabled />)}
            </Form.Item>
          </Col>

          {isEdit && (
            <Col span={6}>
              <Form.Item colon={false} label={formatMessage(text.form.prev)}>
                {getFieldDecorator(`prevVersion`, {
                  initialValue: get(currentValue, `prevVersion`),
                })(<Input type="text" size="large" disabled />)}
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row gutter={24}>{this.renderTnCEditor(lang)}</Row>
      </div>
    );
  };

  renderForm = () => {
    const lang = this.state.step === 0 ? 'en' : 'id';

    return (
      <Form>
        {this.renderFormTab('en', lang === 'en')}
        {this.renderFormTab('id', lang === 'id')}

        <div className="btn-group">
          <Button
            type="primary"
            className="btn btn-submit"
            onClick={this.handleSubmit}
            loading={this.props.loading}
          >
            {lang === 'en' ? 'Next' : 'Save'}
          </Button>
          <Button
            type="default"
            className="btn btn-cancel"
            onClick={this.handlePreview}
          >
            Preview
          </Button>
          <Button
            type="default"
            className="btn btn-cancel"
            onClick={this.handleCancel}
          >
            {lang === 'en' ? 'Cancel' : 'Back'}
          </Button>
        </div>
      </Form>
    );
  };

  render() {
    const { currentValue } = this.props;
    return (
      <div id="tnc-form">
        <div className="step-language">
          <Steps current={this.state.step === 2 ? 1 : 0}>
            <Step
              title="English"
              description="Configure terms & condition language in English."
            />
            <Step
              title="Indonesian"
              description="Configure terms & condition language in Bahasa."
            />
          </Steps>
        </div>

        <div className="title-form">
          {this.props.isEdit ? 'Update' : 'Create'} Terms & Conditions
        </div>

        {this.renderForm()}

        {this.state.tncModalVisible && (
          <TncPreviewModal
            modalVisible={this.state.tncModalVisible}
            onClose={() => {
              this.setState({ tncModalVisible: false });
            }}
            title="Preview"
            selectedLang={this.state.step === 0 ? 'en' : 'id'}
            tnc={{
              name: get(currentValue, 'name'),
              fileVersion: get(currentValue, 'fileVersion'),
              prevVersion: get(currentValue, 'prevVersion'),
              tncContent: this.state.tncContent,
            }}
          />
        )}
      </div>
    );
  }
}

TncForm.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  currentValue: PropTypes.object,
  history: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  loading: PropTypes.bool,
};

export default withRouter(TncForm);
